const accordionToggle = () => {
    // Select all accordion headers
    const accordionHeaders = document.querySelectorAll('.accordion-item .accordion-header');

    // Add click event to each accordion header
    accordionHeaders.forEach(header => {
        header.addEventListener('click', function() {
            const accordionItem = this.closest('.accordion-item');
            const accordionContent = accordionItem.querySelector('.accordion-content');

            // Close all other open accordion items
            document.querySelectorAll('.accordion-item.active').forEach(activeItem => {
                if (activeItem !== accordionItem) {
                    activeItem.classList.remove('active');
                    activeItem.querySelector('.accordion-content').style.display = 'none';
                }
            });

            // Toggle the current accordion item
            if (accordionItem.classList.contains('active')) {
                accordionItem.classList.remove('active');
                accordionContent.style.display = 'none';
            } else {
                accordionItem.classList.add('active');
                accordionContent.style.display = 'block';
            }
        });
    });

    document.querySelectorAll('.accordion-content').forEach(content => {
        content.style.display = 'none';
    });
}

document.addEventListener("DOMContentLoaded", function() {
    accordionToggle();
});
